import React from 'react';
import { Link } from 'react-router-dom';

type MobileNavigationBrandProps = {
  onNavigate?: () => void;
};

const MobileNavigationBrand: React.FC<MobileNavigationBrandProps> = ({
  onNavigate,
}) => {
  return (
    <Link
      className="mobile-navigation-brand"
      aria-label="Wildcard home"
      to="/"
      onClick={onNavigate}
    >
      <img
        className="mobile-navigation-brand__logo"
        src={require('../../static/img/logos/wildcard-logo-horz-tagline-reverse-cr.png')}
        alt="Wildcard"
      />

      <span className="mobile-navigation-brand__name">Wildcard</span>
    </Link>
  );
};

export default MobileNavigationBrand;
